import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  getUserId,
  getUserLanguage,
  getTempLanguage,
} from "../api/sessionManagement";

interface LanguageInitializerProps {
  children: React.ReactNode;
}

export const LanguageInitializer = ({ children }: LanguageInitializerProps) => {
  const { i18n } = useTranslation();
  const [isLanguageInitialized, setIsLanguageInitialized] = useState(false);

  useEffect(() => {
    const initializeLanguage = async () => {
      try {
        const userId = getUserId();
        let targetLanguage: string | null = null;

        if (userId) {
          targetLanguage = getUserLanguage(userId);
        } else {
          targetLanguage = getTempLanguage();
        }

        if (!targetLanguage) {
          targetLanguage =
            localStorage.getItem("i18nextLng") ||
            sessionStorage.getItem("i18nextLng") ||
            navigator.language ||
            "en-GB";
        }

        if (i18n.language !== targetLanguage) {
          await i18n.changeLanguage(targetLanguage);
        }

        await i18n.loadLanguages(targetLanguage);
      } catch (error) {
        console.error("Language initialization error:", error);
      } finally {
        setIsLanguageInitialized(true);
      }
    };

    initializeLanguage();
  }, [i18n]);

  if (isLanguageInitialized || i18n.isInitialized) {
    return <>{children}</>;
  }

  return null;
};
